import _ from 'lodash';

import { default as SendSmsBase } from 'actions/composition/send_sms';
import AddGreetingSuggestion from 'actions/greeting_suggestions/add_greeting_suggestion';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default class SendSms {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId, content, customerId }) {
    const composition = getCompositionsStore(this.context, customerId).findBy({ id: compositionId });
    if (!composition) {
      return;
    }

    const compositionContent = composition.toJs().content;
    _.forEach(content, (html, attr) => {
      compositionContent[attr] = html;
    });

    this.context.executeAction(AddGreetingSuggestion, {
      customerId,
      messageText: content.body,
    });

    this.context.executeAction(SendSmsBase, {
      compositionId,
      content: compositionContent,
    });
  }
}
